export const cssExt = '.css';
export const scssExt = '.scss';
export const htmlExt = '.html';
export const mapExt = '.map';
export const minExt = '.min';
export const jsExt = '.js';
export const svelteExt = '.svelte';
export const svgExt = '.svg';
export const jpgExt = '.jpg';
export const pngExt = '.png';
